import React, { useEffect, useState } from "react";
import Drawer from "react-bottom-drawer";
import SmcasePopupLoaderMob from "../../SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupSuccessMob from "../../SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupFailMob from "../../SMCaseLoadPopup/SmcasePopupFailMob";
import di from "../../di/servicelocator";
import { useSelector } from "react-redux";
const HoldingSmallCaseReportMob = (props) => {
    const [smallCase, setSmallCase] = useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const downloadStatus = useSelector((state) => state.holdingReport.downloadStatus);
    const downloadSmallCaseReport = async () => {
        setSmallCase(true);
        openDrawerLoader();
        di.holdingReport.downloadSmallCaseReport();
    };
    useEffect(() => {
        downloadSmallCaseReport();
    }, []);
    React.useEffect(() => {
        if (smallCase && downloadStatus.isOpen !== null) {
            closeDrawerLoader();
            if (downloadStatus.isOpen === true) {
                openDrawerDownloadS();
            }
            if (downloadStatus.isOpen === false) {
                openDrawerFail();
            }
        }
    }, [downloadStatus.isOpen]);
    const openDrawerLoader = React.useCallback(() => setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => {
        setDownloadFail(true);
    }, []);
    const closeDrawerLoader = React.useCallback(() => setShowLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => {
        setDownloadFail(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm mobForm" },
            React.createElement(Drawer, { isVisible: showLoader, onClose: closeDrawerLoader, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement(SmcasePopupLoaderMob, { Title: "Holdings", closeDrawer: closeDrawerLoader })),
            React.createElement(Drawer, { isVisible: downloadSuccess, onClose: closeDrawerDownloadS, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement("div", null,
                    React.createElement(SmcasePopupSuccessMob, { Title: "Holdings", closeDrawer: closeDrawerDownloadS, operation: "download", pageName: "Holding" }))),
            React.createElement(Drawer, { isVisible: downloadFail, onClose: closeDrawerFail, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                React.createElement("div", null,
                    React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: "download", pageName: "Holding" }))))));
};
export default HoldingSmallCaseReportMob;
